export default "__VITE_ASSET__BHnmb7HU__"